import Navbar from 'components/Navbar'
import React from 'react'
import ContactForm from 'components/ContactUs/ContactForm';
import Footer from 'components/Footer';
import { useSelector } from 'react-redux';
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';
import { useEffect } from "react";

function ContactUs() {

  const isMobile = useSelector(state=> state.windowSize.isMobile)
  
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);
  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbar />
      <ContactForm />
      <MobileFooter />
      </>
    ) : (
      <>
      <Navbar />
      <ContactForm />
      <Footer />
      </>
    )}
    </>
  )
}

export default ContactUs